import { DEFAULT_PATH, canOpenModule } from "@/lib/nav";
import type { OrgRole } from "@/types/api";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

/**
 * A tab's route, open only to a viewer the nav would show it to
 * (lib/nav.ts canOpenModule). The tab is hidden from them; this covers a typed
 * URL. While the role is still loading it renders nothing, so an admin is not
 * sent away from a page they may open.
 */
export function ModuleRoute({
	module,
	role,
	children,
}: {
	module: string;
	role: OrgRole | undefined;
	children: ReactNode;
}) {
	if (canOpenModule(module, { role })) return <>{children}</>;
	if (role === undefined) return null;
	return <Navigate to={DEFAULT_PATH} replace />;
}
